import {
  isAdminPermission as isAdminPermissionNewLocation,
  isAdminUserPermission as isAdminUserPermissionNewLocation,
  isSocietyAdminPermission as isSocietyAdminPermissionNewLocation,
} from "shared/admin-permissions/permissionGuards";
import { getPermissionDefinition as getPermissionDefinitionNewLocation } from "shared/admin-permissions/permissionLookup";
import {
  type AdminPermissions as AdminPermissionsNewLocation,
  AdminUserPermissions as AdminUserPermissionsNewLocation,
  SocietyAdminPermissions as SocietyAdminPermissionsNewLocation,
} from "shared/admin-permissions/permissionNames";

/**
 * @deprecated Import from `shared/admin-permissions/permissionGuards`
 */
export const isAdminPermission = isAdminPermissionNewLocation;
/**
 * @deprecated Import from `shared/admin-permissions/permissionGuards`
 */
export const isAdminUserPermission = isAdminUserPermissionNewLocation;
/**
 * @deprecated Import from `shared/admin-permissions/permissionGuards`
 */
export const isSocietyAdminPermission = isSocietyAdminPermissionNewLocation;
/**
 * @deprecated Import from `shared/admin-permissions/permissionLookup`
 */
export const getPermissionDefinition = getPermissionDefinitionNewLocation;
/**
 * @deprecated Import from `shared/admin-permissions/permissionNames`
 */
export const AdminUserPermissions = AdminUserPermissionsNewLocation;
/**
 * @deprecated Import from `shared/admin-permissions/permissionNames`
 */
export type AdminUserPermissions = AdminUserPermissionsNewLocation;
/**
 * @deprecated Import from `shared/admin-permissions/permissionNames`
 */
export const SocietyAdminPermissions = SocietyAdminPermissionsNewLocation;
/**
 * @deprecated Import from `shared/admin-permissions/permissionNames`
 */
export type SocietyAdminPermissions = SocietyAdminPermissionsNewLocation;
/**
 * @deprecated Import from `shared/admin-permissions/permissionNames`
 */
export type AdminPermissions = AdminPermissionsNewLocation;
